export function startAudioPreview(localStream, liveArea, onReady, extraClass = '') {
  liveArea.innerHTML = `
        <div id="micVisualizerContainer" class="canvas-ckeditor ${extraClass}"
             style="position:relative; width:100%; text-align:center; border-radius:8px; padding:25px; overflow:hidden;">

            <canvas id="micVisualizer" class="canvas-ckeditor" width="500" height="120"
                    style="width:100%; border-radius:8px; position:relative;"></canvas>

            <i class="fas fa-microphone microphone-ckeditor"
               style="position:absolute; left:10px; top:10px; font-size:22px; z-index:3;"></i>

            <!-- Overlay tenue desde el inicio -->
            <div id="countdownOverlay"
                style="
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 3;
                    background: rgba(0, 0, 0, 0.02);
                    color: white;
                    font-size: 100px;
                    font-weight: 400;
                    border-radius: 5px;
                    opacity: 1;
                    transition: opacity 0.8s;
                    border-style: solid;
                    border-width: 1px;
                    border-color: #EEEEEE;
                ">
            </div>

            <div id="recordingOverlay"
                style="
                    position:absolute;
                    top:10px;
                    left:50%;
                    transform:translateX(-50%);
                    display:none;
                    align-items:center;
                    gap:8px;
                    background:rgba(20,20,20,0.55);
                    color:white;
                    font-weight:400;
                    border-radius:5px;
                    padding:6px 12px;
                    z-index:6;
                    box-shadow:0 0 8px rgba(0,0,0,0.2);
                    backdrop-filter:blur(5px);
                ">
                <div class="record-dot" 
                    style="width:10px;height:10px;border-radius:50%;background:red;animation:blinkDot 1s infinite;">
                </div>
                <span id="recStatusText">Grabando</span>
                <span id="recTimerText" style="margin-left:6px;">00:00</span>

                <style>
                    @keyframes blinkDot {
                        0%, 50%, 100% { opacity: 1; }
                        25%, 75% { opacity: 0; }
                    }
                </style>
            </div>
        </div>
    `;

    // --- Configuración del visualizador de onda ---
    const canvas = document.getElementById('micVisualizer');
    const ctx = canvas.getContext('2d');

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const source = audioCtx.createMediaStreamSource(localStream);
    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 1024;
    source.connect(analyser);

    const bufferLength = analyser.fftSize;
    const dataArray = new Uint8Array(bufferLength);

    // Color dinámico del sistema
    const temp = document.createElement('div');
    temp.classList.add('bar-audio-ckeditor');
    document.body.appendChild(temp);
    const waveformColor = getComputedStyle(temp).backgroundColor;
    document.body.removeChild(temp);

    const width = canvas.width;
    const height = canvas.height;

    const bgGradient = ctx.createLinearGradient(0, 0, 0, height);
    bgGradient.addColorStop(0, "#fff");
    bgGradient.addColorStop(1, "#fff");

    function drawWaveform() {
        requestAnimationFrame(drawWaveform);
        analyser.getByteTimeDomainData(dataArray);

        ctx.fillStyle = bgGradient;
        ctx.fillRect(0, 0, width, height);

        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = waveformColor;

        const sliceWidth = width / bufferLength;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
            const v = dataArray[i] / 128.0;
            const y = (v * height) / 2;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
            x += sliceWidth;
        }

        ctx.lineTo(width, height / 2);
        ctx.stroke();
    }
    drawWaveform();

    // --- Overlays ---
    const countdownOverlay = document.getElementById('countdownOverlay');
    const recordingOverlay = document.getElementById('recordingOverlay');
    const recStatusText = document.getElementById('recStatusText');
    const recTimerText = document.getElementById('recTimerText');

    let recTimerInterval = null;
    let recSeconds = 0;
    let recState = 'stopped'; // 'recording' | 'paused' | 'stopped'

    // --- Muestra la cuenta regresiva con fondo sutil al finalizar ---
    window._showCountdownOverlay = function (seconds = 3, callback) {
        countdownOverlay.style.display = 'flex';
        countdownOverlay.style.opacity = '1';
        countdownOverlay.textContent = seconds;
        countdownOverlay.style.zIndex = '5';
        countdownOverlay.style.background = 'rgba(0,0,0,0.45)';

        const interval = setInterval(() => {
            seconds--;
            if (seconds > 0) {
                countdownOverlay.textContent = seconds;
            } else {
                clearInterval(interval);

                // Desvanecer overlay y dejar fondo tenue
                countdownOverlay.textContent = '';
                countdownOverlay.style.transition = 'opacity 0.8s ease';
                countdownOverlay.style.opacity = '0';
                countdownOverlay.style.borderStyle = 'solid';
                countdownOverlay.style.borderWidth = '1px';
                countdownOverlay.style.borderColor = '#EEEEEE';

                setTimeout(() => {
                    countdownOverlay.style.zIndex = '1';
                    countdownOverlay.style.display = 'flex';
                    countdownOverlay.style.background = 'rgba(0,0,0,0.02)';
                    countdownOverlay.style.opacity = '1';
                }, 800);

                if (typeof callback === 'function') callback();
            }
        }, 1000);
    };

    // --- Iniciar grabación visualmente ---
    window._startRecordingOverlay = function () {
        recState = 'recording';
        recSeconds = 0;
        updateTimerDisplay();
        recordingOverlay.style.display = 'flex';
        recStatusText.textContent = 'Grabando';
        const dot = recordingOverlay.querySelector('.record-dot');
        if (dot) dot.style.animationPlayState = 'running';
        if (recTimerInterval) clearInterval(recTimerInterval);
        recTimerInterval = setInterval(() => {
            if (recState === 'recording') {
                recSeconds++;
                updateTimerDisplay();
            }
        }, 1000);
    };

    // --- Pausar grabación ---
    window._pauseRecordingOverlay = function () {
        recState = 'paused';
        recStatusText.textContent = 'Pausado';
        const dot = recordingOverlay.querySelector('.record-dot');
        if (dot) dot.style.animationPlayState = 'paused';
    };

    // --- Reanudar grabación ---
    window._resumeRecordingOverlay = function () {
        recState = 'recording';
        recStatusText.textContent = 'Grabando';
        const dot = recordingOverlay.querySelector('.record-dot');
        if (dot) dot.style.animationPlayState = 'running';
    };

    // --- Detener grabación ---
    window._stopRecordingOverlay = function () {
        recState = 'stopped';
        clearInterval(recTimerInterval);
        recordingOverlay.style.display = 'none';
        const dot = recordingOverlay.querySelector('.record-dot');
        if (dot) dot.style.animationPlayState = 'paused';
    };

    function updateTimerDisplay() {
        const mins = String(Math.floor(recSeconds / 60)).padStart(2, '0');
        const secs = String(recSeconds % 60).padStart(2, '0');
        recTimerText.textContent = `${mins}:${secs}`;
    }

    if (typeof onReady === 'function') onReady();
}
